<template>
  <v-app>
    <v-app-bar app>
      <img
        :src="require('./assets/pcc_logo.png')"
        height="40"
      >
      <router-link to="/">
        <v-app-bar-title class="ml-3 font-weight-bold black--text">預約停車平台</v-app-bar-title>
      </router-link>
    </v-app-bar>
    <v-main>
      <snackbar />
      <router-view />
    </v-main>
    <v-footer
      color="primary"
      padless
    >
      <v-card
        flat
        tile
        class="flex indigo lighten-1 white--text text-center"
      >
        <v-card-text class="primary lighten-2 white--text pt-0 pb-0">
          <v-row
            justify="center"
            no-gutters
          >
            <v-col
              class="text-center white--text"
              cols="12"
            >
              聯絡資訊: 115-025 台北市南港區忠孝東路六段66號1樓
            </v-col>
            <v-col
              class="text-center white--text"
              cols="12"
            >
              客服電話:0800-021-111
            </v-col>
            <v-col
              class="text-center white--text"
              cols="12"
            >
              E-Mail:park_service@youparking.com.tw
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text class="white--text">
          <v-icon
            dark
            small
          >mdi-copyright</v-icon> <strong>九亭股份有限公司 All Rights Reserved</strong>
        </v-card-text>
      </v-card>
    </v-footer>
    <overlay />
  </v-app>
</template>
<style>
table thead th {
  font-size: 20px !important;
  font-weight: bold !important;
}
</style>
<script>
import Snackbar from '@/components/Snackbar.vue';
import Overlay from '@/components/Overlay.vue';

export default {
  name: 'App',

  components: {
    Snackbar,
    Overlay
  },

  data: () => ({})
};
</script>
